__turbopack_context__.v({
  "googleButton": "style-module-scss-module__5m5W6q__googleButton",
});
